{
    "longSHA": "73d014d139c82b7bde1d6ca4c4673949e5b1b513",
    "shortSHA": "73d014d",
    "branch": "development",
    "authorName": "Luka Ernestini",
    "commitTime": "Tue Apr 21 11:47:01 2026 +0200",
    "commitMsg": "feat: add invoice status reports\n\nRefs: #43193",
    "totalCommitCount": "1"
}